export type IntervalMethod = () => Promise<boolean>;

export const useInterval = (fktn: IntervalMethod, delay: number, maxRetries: number) => {
  let timerId: NodeJS.Timeout | null = null;
  let running = false;
  let retries = 0;
  let resolvePromise: (() => void) | null = null;

  const callFunction = async () => {
    try {
      retries++;

      const result = await fktn();

      if (result) {
        running = false;
        if (resolvePromise) resolvePromise();
      } else if (running && retries < maxRetries) {
        await run();
      } else {
        running = false;
      }
    } catch (error) {
      console.error('[useInterval] Error executing function:', error);
      running = false;
    }
  };

  const run = async () => {
    timerId = setTimeout(async () => {
      if (!running) return;

      await callFunction();
    }, delay);
  };

  const start = async (immediate: boolean) => {
    if (timerId !== null) return; // Already running

    return new Promise<void>((resolve) => {
      running = true;
      retries = 0;
      resolvePromise = resolve;

      if (immediate) {
        callFunction();
      } else {
        run();
      }
    });
  };

  const stop = () => {
    running = false;

    if (timerId !== null) {
      clearTimeout(timerId);
      timerId = null;
    }
  };

  return { start, stop };
};
